import type { TokenDefinition, } from "../../types"


// https://docs.chain.link/data-feeds/price-feeds/addresses?network=ethereum&page=1&search=RETH

export const definitions: TokenDefinition[] = [
	{
		label: "ETH",
		name: "Ethereum",
		symbol: "ETH",
		decimals: 18,
		logoURI: "https://cdn.iconscout.com/icon/free/png-256/free-ethereum-1824287-1545899.png",
		priceFeedAddress: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419", // USD
		chainId: 188,
		address: "0x0",
		fees: [ ],
		swapto: false,
		swapable: true,
		parity: true,
	},
	{
		name: "wrapped ether",
		symbol: "WETH",
		label: "wETH",
		chainId: 188,
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		priceFeedAddress: "0xCc72039A141c6e34a779eF93AEF5eB4C82A893c7",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
		extensions: {
			"bridgeInfo": {
				"10": {
					"tokenAddress": "0x4200000000000000000000000000000000000006"
				},
				"56": {
					"tokenAddress": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
				},
				"137": {
					"tokenAddress": "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
				},
				"8453": {
					"tokenAddress": "0x4200000000000000000000000000000000000006"
				},
				"42161": {
					"tokenAddress": "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
				},
				"42220": {
					"tokenAddress": "0x2DEf4285787d58a2f811AF24755A8150622f4361"
				},
				"43114": {
					"tokenAddress": "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
				}
			}
		},
		fees: [ ],
		swapto: false,
		swapable: true,
		parity: true,
	},
	{
		name: "ankrETH",
		symbol: "ANKRETH",
		label: "ankrETH",
		chainId: 188,
		address: "0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
		priceFeedAddress: "0xNEED",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978",
		extensions: {
			"bridgeInfo": {
				"56": {
					"tokenAddress": "0xf307910A4c7bbc79691fD374889b36d8531B08e3"
				},
				"42161": {
					"tokenAddress": "0x1bfc5d35bf0f7B9e15dc24c78b8C02dbC1e95447"
				},
				"43114": {
					"tokenAddress": "0x20CF1b6E9d856321ed4686877CF4538F2C84B4dE"
				}
			}
		},
		fees: [ ],
		swapto: false,
		stakable: true,
		parity: false,
	},
	{
		name: "wrapped liquid staked ether",
		symbol: "WSTETH",
		label: "wstETH",
		chainId: 188,
		address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
		priceFeedAddress: "0xNEED",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/wsteth3_32.png",
		extensions: { },
		fees: [ 100, ],
		swapto: true,
		stakable: true,
		parity: false,
	},
	{
		name: "stETH",
		symbol: "STETH",
		label: "stETH",
		chainId: 188,
		address: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
		priceFeedAddress: "0x86392dC19c0b719886221c78AB11eb8Cf5c52812",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/wsteth3_32.png",
		extensions: { },
		fees: [ 100, ],
		stakable: true,
		parity: true,
		swapto: false,
	},
	{
		name: "rocket pool ether",
		symbol: "RETH",
		label: "rETH",
		chainId: 188,
		address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
		priceFeedAddress: "0x536218f9E9Eb48863970252233c8F271f554C2d0",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/rocketpooleth_32.png?v=2",
		extensions: { },
		fees: [ 500, 3000 ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "ether.fi ETH",
		symbol: "EETH",
		label: "eETH",
		chainId: 188,
		address: "0x35fA164735182de50811E8e2E824cFb9B6118ac2",
		priceFeedAddress: "0xNEED",
		decimals: 18,
		logoURI: "/assets/crypto/eeth.png",
		extensions: { },
		fees: [ 0, ],
		stakable: true,
		parity: true,
		swapto: false,
	},
	{
		name: "rsETH",
		symbol: "RSETH",
		label: "rsETH",
		chainId: 188,
		address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
		priceFeedAddress: "0x03c68933f7a3F76875C0bc670a58e69294cDFD01",
		decimals: 18,
		logoURI: "https://img.cryptorank.io/coins/60x60.kelp_dao_restaked_eth1716362924229.png",
		extensions: { },
		fees: [ 10000, 3000, 500 ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "wrapped eETH",
		symbol: "WEETH",
		label: "weETH",
		chainId: 188,
		address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
		priceFeedAddress: "0x5c9C449BbC9a6075A2c061dF312a35fd1E05fF22",
		decimals: 18,
		logoURI: "https://arbiscan.io/token/images/etherfiweeth_32.png",
		extensions: { },
		fees: [ 100, 3000, ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "ezETH",
		symbol: "EZETH",
		label: "ezETH",
		chainId: 188,
		address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
		priceFeedAddress: "0x636A000262F6aA9e1F094ABF0aD8f645C44f641C",
		decimals: 18,
		logoURI: "https://etherscan.io/token/images/ezETHv2_32.png",
		extensions: { },
		fees: [ 100, 10000, 500, ],
		stakable: true,
		parity: false,
		swapto: true,
		inactive: true,
		disabled: true,
	},
	{
		name: "os eth",
		symbol: "OSETH",
		label: "osETH",
		chainId: 188,
		address: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
		decimals: 18,
		logoURI: "/assets/crypto/oseth.png",
		extensions: { },
		fees: [ 100, 10000, 500, ],
		stakable: true,
		parity: false,
		swapto: false,
	},
	{
		name: "Coinbase Assets",
		symbol: "CBETH",
		label: "cbETH",
		chainId: 188,
		address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
		decimals: 18,
		logoURI: "/assets/crypto/CBETH.png",
		extensions: { },
		fees: [ 100, ],
		stakable: true,
		parity: false,
		swapto: true,
	},
	{
		name: "sfrxETH",
		symbol: "SFRXETH",
		label: "sfrxETH",
		chainId: 188,
		address: "0xac3E018457B222d93114458476f3E3416Abbe38F",
		decimals: 18,
		logoURI: "/assets/crypto/SFRXETH.png",
		extensions: { },
		fees: [ ],
		stakable: true,
		parity: false,
		swapto: false,
	},
	{
		name: "stone",
		symbol: "STONE",
		label: "STONE",
		chainId: 188,
		address: "0x7122985656e38BDC0302Db86685bb972b145bD3C",
		decimals: 18,
		logoURI: "/assets/crypto/STONE.png",
		extensions: { },
		fees: [ ],
		stakable: true,
		parity: false,
		swapto: false,
		// disabled: true,
	}
];
